/* eslint no-param-reassign: "off" */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import School from '../../types/School';

interface State {
  ids: number[];
  values: Record<number, School>;
}

const initialState: State = {
  ids: [],
  values: {},
};

const schoolsSlice = createSlice({
  name: 'schools',
  initialState,
  reducers: {
    addSchool: (state, action: PayloadAction<School>) => {
      const { id } = action.payload;
      state.ids.push(id);
      state.values[id] = action.payload;
    },

    updateSchool: (state, action: PayloadAction<School>) => {
      const { id } = action.payload;
      state.values[id] = action.payload;
    },

    deleteSchool: (state, action: PayloadAction<number>) => {
      const id = action.payload;
      state.ids.splice(state.ids.indexOf(id), 1);
      delete state.values[id];
    },

    setAllSchools: (state, action: PayloadAction<School[]>) => {
      state.ids = [];
      state.values = {};

      action.payload.forEach((value) => {
        const { id } = value;
        state.ids.push(id);
        state.values[id] = value;
      });
    },
  },
});

export const selectSchools = (state: any): Record<number, School> =>
  state.schools.values;

export const { setAllSchools, addSchool, updateSchool, deleteSchool } =
  schoolsSlice.actions;
export default schoolsSlice.reducer;
